<template>
  <div>
    <div v-if="lesson" class="channel-lesson m-auto">
      <live-player :liveData="lesson" v-if="lesson" />
    </div>
    <div class="assisted col-12">
      <div class="assisted-box">
        <div class="d-flex">
          <h4 class="mx-3">單字學習</h4>
          <h4>必備句子</h4>
        </div>
        <div>
          <ul class="list-group list-group-flush assisted-info">
            <li class="list-group-item"  v-for="(item, index) in vocabularies" :key="index">
              <h5>{{item.name}}  [ɪnˈdjur] v. 忍受；忍耐</h5>
              <p class="list-text">
                As a child, he was forced to endure poverty and war.
              </p>
              <p class="list-text">
                他小時候被迫忍受貧窮與戰爭。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
// import apiLibrary from '../store/library/api'
import api from '../store/api'
import LivePlayer from 'live-player'

export default {
  name: 'ChannelLesson',
  data () {
    return {
      timer: null,
      time: 0,
      lesson: null,
      lessonId: this.$route.params.lessonId,
      vocabularies: []
    }
  },
  mounted () {
    this.getLesson(this.lessonId)
  },
  async beforeDestroy () {
    if (this.tab === 'player') {
      if (this.lesson.id) {
        const fileData = new window.FormData()
        fileData.append('seconds', this.time)
        await personalApi.post(`records/lesson/${this.lesson.id}/time`, fileData)
        clearInterval(this.timer)
        this.recordTimer = null
      } else {
        clearInterval(this.timer)
        this.recordTimer = null
      }
    }
  },
  methods: {
    async getLesson (id) {
      // const { data } = await apiLibrary.get(`/v1/livelibrary/Lesson/${id}`)
      const { data } = await api.get(`/contents/lesson/${id}`)
      if (data.status === 'OK') {
        if (data.data.lessonType) {
          this.getLesson(data.data.lessons[0].id)
          this.vocabularies = data.data.lessons[0].modules[0].vocabularies
        } else {
          this.lesson = data.data
          this.vocabularies = data.data.modules[0].vocabularies
        }
      }
    },
    countup () {
      this.time++
    },
    async counter (el) {
      // console.log(el)
      if (el === 'playing') {
        // this.time++
        this.timer = setInterval(this.countup, 1000)
      } else {
        const fileData = new window.FormData()
        fileData.append('seconds', this.time)
        await personalApi.post(`records/lesson/${this.lessonId}/time`, fileData)
        this.time = 0
        clearInterval(this.timer)
      }
    }
  },
  components: {
    // Video,
    LivePlayer
  }
}
</script>
<style lang="scss" scoped>
  .channel-lesson {
    // min-height:600px;
    // max-width: 75%;
  }
  .assisted {
    width: 100%;
    padding: 20px;
    background-color: rgb(179, 201, 198);
    .assisted-box {
      text-align: left;
      border-radius: 10px;
      width: 80%;
      padding: 20px;
      margin: 50px auto;
      background-color: #fff;
      .assisted-info {
        padding: 10px;
        height: 400px;
        overflow: auto;
        .list-text {
          margin: 0;
        }
      }
    }
  }
</style>
